export default __webpack_public_path__ + "static/media/season_winter.d31d4d65.avif";